import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { SENTRY_ENV } from '@/utils/env'

function version (): string {
  const git = import.meta.env.VITE_GIT_VERSION_LONG
  if (typeof git !== 'string') {
    return 'dev'
  }
  return git
}

function init (): void {
  Sentry.init({
    dsn: 'https://37df24f87ae44acd85dea48f17e837fa@o1098110.ingest.sentry.io/6120081',
    release: `forum-v3@${version()}`,
    environment: SENTRY_ENV,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [
          'localhost',
          'local.forum.ircam.fr',
          'staging.forum.ircam.fr',
          'testing.forum.ircam.fr',
          'forum.ircam.fr',
          /^\//
        ]
      })
    ],
    logErrors: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // May need adjustments in production
    tracesSampleRate: 1.0
  })
}

// enable in production / staging mode only
if (import.meta.env.MODE !== 'development') {
  init()
}
